// Extend namespace by creating a new object
pyzel.maps = {};

/**
 * Initialize listeners
 *
 * @return {void}
 */
pyzel.maps.init = function() {

	$('.map').click(function(){
		$(this).find('iframe').addClass('clicked')
	}).mouseleave(function(){
		$(this).find('iframe').removeClass('clicked')
	});

};